/**
 *
 * ManduUsersList
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Table } from "antd"
import imgCheck from "../../images/check-measure.svg"
import { ROLE_MANDU_SUPER_ADMIN } from "../../utils/constants"

/* eslint-disable react/prefer-stateless-function */
class ManduUsersTable extends React.Component {
  state = { sortedInfo: null }

  handleChange = (pagination, filters, sorter) => {
    this.setState({ sortedInfo: sorter })
  }

  render() {
    let { sortedInfo } = this.state
    const { users, isLoading } = this.props
    sortedInfo = sortedInfo || {}
    const columns = [
      {
        title: "Nombre",
        dataIndex: "first_name",
        key: "first_name",
        render: (text, record) => (
          <span
            className="color-blue truncateCss"
            style={{ cursor: "pointer" }}
            onClick={() => this.props.userSelected(record)}>
            {text}{" "}
          </span>
        ),
        sorter: (a, b) => a.first_name.localeCompare(b.first_name),
        sortOrder: sortedInfo.columnKey === "first_name" && sortedInfo.order,
        width: 200,
      },
      {
        title: "Apellidos",
        dataIndex: "last_name",
        key: "last_name",
        sorter: (a, b) => a.last_name.localeCompare(b.last_name),
        render: (text, record) => <span className="truncateCss">{text} </span>,
        sortOrder: sortedInfo.columnKey === "last_name" && sortedInfo.order,
        width: 200,
      },
      {
        title: "Correo electrónico",
        dataIndex: "email",
        width: 200,
      },
      {
        title: "Módulo",
        dataIndex: "platform_name",
        width: 170,
      },
      {
        title: "Superadministrador",
        dataIndex: "service",
        render: (text, record) => (
          <span>
            {record.id_role == ROLE_MANDU_SUPER_ADMIN ? (
              <img height={12} src={imgCheck} />
            ) : (
              "-"
            )}{" "}
          </span>
        ),
        width: 210,
      },
    ]
    return (
      <Table
        loading={isLoading}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={Array.isArray(users) ? users : []}
        onChange={this.handleChange}
        pagination={{
          pageSizeOptions: ["15", "25", "50", "100"],
          showSizeChanger: true,
          size: "default",
          defaultPageSize: 15,
        }}
      />
    )
  }
}

ManduUsersTable.propTypes = {}

export default ManduUsersTable
